var map = {
	"./Tokens/Background/AltBackground.demo.js": 1083,
	"./Tokens/Background/AppBackground.demo.js": 1084,
	"./Tokens/Background/OverlayBackground.demo.js": 1085,
	"./Tokens/Background/UiBackground.demo.js": 1086,
	"./Tokens/Border/Borders.demo.js": 1087,
	"./Tokens/State/StateColors.demo.js": 1088,
	"./Tokens/Text/Text.demo.js": 1097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;